
const API_URL = process.env.VUE_APP_SERVER_URL;

export function getImageUrl(imagePath) {
    if (!imagePath) return '';
    return `${API_URL}${imagePath}`;
}
    